module.exports = __webpack_public_path__ + "img/relvado_fr.a2d073bb.jpg";